var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map__app" }, [
    _c("div", { staticClass: "map__desc-wrapper" }, [
      !_vm.activePoint.isWorldMap
        ? _c("div", {
            staticClass: "map__desc",
            domProps: { innerHTML: _vm._s(_vm.$t("map.desc")) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.activePoint.isWorldMap
        ? _c("div", {
            staticClass: "map__desc",
            domProps: { innerHTML: _vm._s(_vm.$t("map.descWorld")) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "map__container-desktop" },
        [
          _c(
            "mq-layout",
            { attrs: { mq: ["desktop", "tablet"] } },
            [
              _c("MapElement", {
                attrs: {
                  activePoint: _vm.activePoint,
                  imgDebug: _vm.imgDebug,
                  getCities: _vm.getCities,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "map__data map__data_desktop" }, [
      _c(
        "div",
        { staticClass: "map__countries" },
        _vm._l(_vm.points, function (point) {
          return _c("div", {
            staticClass: "map__country",
            class: point.isActive ? "map__country_active" : "",
            domProps: { textContent: _vm._s(_vm.$t(point.country)) },
            on: {
              click: function ($event) {
                return _vm.activatePoint(point)
              },
            },
          })
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "map__offices-container" },
        _vm._l(_vm.points, function (point) {
          return _c(
            "div",
            [
              _c("collapse-transition", { attrs: { duration: 500 } }, [
                point.isActive
                  ? _c(
                      "div",
                      { key: point.id, staticClass: "map__office-country" },
                      _vm._l(_vm.$t(point.offices), function (office) {
                        return _c("div", { staticClass: "map__office" }, [
                          _c("div", {
                            staticClass: "map__office-title",
                            domProps: { innerHTML: _vm._s(office.name) },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "map__office-content",
                            domProps: { innerHTML: _vm._s(office.content) },
                          }),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "map__data map__data_mobile" }, [
      _c(
        "div",
        { staticClass: "map__countries" },
        _vm._l(_vm.points, function (point) {
          return _c(
            "div",
            {
              staticClass: "map__country-container",
              class: point.isActive ? "map__country_active" : "",
            },
            [
              _c("div", {
                staticClass: "map__country",
                domProps: { textContent: _vm._s(_vm.$t(point.country)) },
                on: {
                  click: function ($event) {
                    return _vm.activatePoint(point)
                  },
                },
              }),
              _vm._v(" "),
              _c("collapse-transition", { attrs: { duration: 500 } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: point.isActive,
                        expression: "point.isActive",
                      },
                    ],
                    staticClass: "map__country-desc",
                  },
                  [
                    _c("MapElement", {
                      attrs: {
                        "type-map": point.isWorldMap ? "mapWorld" : "mapRussia",
                        activePoint: _vm.activePoint,
                        imgDebug: _vm.imgDebug,
                        getCities: _vm.getCities,
                      },
                    }),
                    _vm._v(" "),
                    _vm.$t(point.offices).length > 1
                      ? _c(
                          "div",
                          {
                            ref: "mapSwiperContainer" + point.id,
                            refInFor: true,
                            staticClass:
                              "swiper-container map__swiper-container",
                          },
                          [
                            _c("div", { staticClass: "map__controls" }, [
                              _c("div", { staticClass: "map__arrows" }, [
                                _c("div", {
                                  staticClass:
                                    "swiper-button-prev map__button-prev",
                                  class: !_vm.canSwipeSlide(point, -1)
                                    ? "map__button-prev_disabled"
                                    : "",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      require("../img/arrow-right.svg")
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.firePreviousSlide(point)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "swiper-button-next map__button-next",
                                  class: !_vm.canSwipeSlide(point, 1)
                                    ? "map__button-next_disabled"
                                    : "",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      require("../img/arrow-right.svg")
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.fireNextSlide(point)
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "swiper-wrapper map__wrapper" },
                              _vm._l(_vm.$t(point.offices), function (office) {
                                return _c(
                                  "div",
                                  { staticClass: "swiper-slide map__slide" },
                                  [
                                    _c("div", { staticClass: "map__office" }, [
                                      _c("div", {
                                        staticClass: "map__office-title",
                                        domProps: {
                                          innerHTML: _vm._s(office.name),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "map__office-content",
                                        domProps: {
                                          innerHTML: _vm._s(office.content),
                                        },
                                      }),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _vm._l(_vm.$t(point.offices), function (office) {
                          return _c("div", [
                            _c("div", { staticClass: "map__office" }, [
                              _c("div", {
                                staticClass: "map__office-title",
                                domProps: { innerHTML: _vm._s(office.name) },
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "map__office-content",
                                domProps: { innerHTML: _vm._s(office.content) },
                              }),
                            ]),
                          ])
                        }),
                  ],
                  2
                ),
              ]),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }